import { styled } from "styled-components";
import { rgba } from "polished";
const TabListWrapper = styled("div")({
  alignItems: "stretch",
  display: "flex",
  flex: "0 1 auto",
  overflow: "hidden",
  padding: "0 8px",
  position: "relative"
});
const TabListScrollOuter = styled("div")(
  {
    alignItems: "stretch",
    display: "flex",
    flexBasis: "auto",
    flexGrow: 0,
    flexShrink: 1,
    margin: "0 -2px",
    overflow: "auto",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none"
    }
  },
  ({ $fadeLeft, $fadeRight }) => ({
    maskImage: `linear-gradient(
      to right,
      ${rgba("black", $fadeLeft ? 0.25 : 1)} 0,
      black 40px,
      black calc(100% - 40px),
      ${rgba("black", $fadeRight ? 0.25 : 1)} 100%
    )`
  }),
  ({ $scrollBehavior }) => ({ scrollBehavior: $scrollBehavior })
);
const TabListScrollInner = styled("div")({
  alignItems: "stretch",
  display: "flex",
  flexBasis: "auto",
  paddingTop: 8,
  transition: "transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)"
});
const TabListInner = styled("ul").attrs({ role: "tablist" })({
  alignItems: "stretch",
  display: "flex",
  listStyle: "none",
  margin: 0,
  padding: "0 2px"
});
const TabListControlBefore = styled("div")({
  alignItems: "center",
  display: "flex",
  paddingRight: 8
});
const TabListControlAfter = styled("div")({
  alignItems: "center",
  display: "flex",
  paddingLeft: 8
});
const TabListItem = styled("li")({
  marginLeft: -1,
  "&:first-child": {
    borderTopLeftRadius: 2,
    marginLeft: 0
  },
  "&:last-child": {
    borderTopRightRadius: 2
  }
});
export {
  TabListControlAfter,
  TabListControlBefore,
  TabListInner,
  TabListItem,
  TabListScrollInner,
  TabListScrollOuter,
  TabListWrapper
};
